import styled from "styled-components";

import { ReactComponent as AutoLoansSVG } from "../assets/svg/auto-loans-icon.svg";
import { ReactComponent as HomeLoansSVG } from "../assets/svg/home-loans-icon.svg";
import { ReactComponent as InvestmentsSVG } from "../assets/svg/investments-icon.svg";
import { ReactComponent as PersonalLoansSVG } from "../assets/svg/personal-loans-icon.svg";
import { ReactComponent as OnlineBankingSVG } from "../assets/svg/online-banking-icon.svg";

export const LandingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  overflow-x: clip;

  @media (min-height: 1360px) {
    min-height: 78vh;
  }
`;
export const LandingBackgroundImage = styled.img`
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: -2;
`;
export const LandingBanner = styled.img`
  position: absolute;
  top: 0;
  right: -40px;
  height: 100%;

  @media (max-width: 1124px) {
    right: 0;
  }
`;
export const FirstRow = styled.div`
  background-color: ${(props) => props.theme.thirdColor};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 1rem 0 1rem 0;
  width: 100%;

  p {
    margin: 0;
    font-size: calc(.5rem + 0.3vw);
  }

  u {
    color: ${(props) => props.theme.firstColor};
    &:hover {
      cursor: pointer;
    }
  }
`;
export const SecondRow = styled.div`
  width: 100%;
  height: clamp(210px, 25vh, 250px);
  background-color: ${(props) => props.theme.firstColor};
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    position: relative;

    @media (max-width: 1366px) {
      max-width: 1024px;
    }
    @media (max-width: 1124px) {
      max-width: none;
      padding: 0 50px;
    }
  }
`;
export const SecondRowContent = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 38%;
  height: 115%;
  padding: 1.2rem;
  z-index: 100;
  position: absolute;
  top: 10%;
  left: 0;
  background-color: ${(props) => props.theme.tenthColor};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.5);
  border-radius: 7px;
  font-size: 0.8rem;

  @media (max-width: 1124px) {
    left: 50px;
  }

  > h2 {
    margin-bottom: 0.3rem;
    font-weight: bold;
    font-size: 1.1rem;
  }

  > p {
    margin-bottom: 0.3rem;
    font-weight: bold;
  }

  && > span {
    margin-bottom: 0.3rem;

    label {
      color: ${(props) => props.theme.firstColor};
      margin-bottom: 0.3rem;
    }
    input {
      padding: 0.3rem;
    }
  }

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  && > div:nth-of-type(1) {
    margin-top: 10px;
    margin-bottom: 10px;

    span {
      display: flex;
      align-items: center;
    }

    button {
      padding: 0.3rem 3rem;
    }
  }

  && > div:nth-of-type(2) {
    u {
      font-weight: bold;
      color: ${(props) => props.theme.secondColor};
      &:hover {
        cursor: pointer;
      }
    }
  }
`;
export const ThirdRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 7vh;
  width: 100%;
  max-width: 1200px;
  position: relative;

  @media (max-width: 1366px) {
    max-width: 1024px;
  }
  @media (max-width: 1124px) {
    max-width: none;
    padding: 0 50px 40px 50px;
  }
`;
export const LandingBackground = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100vw;
  height: 100%;

  > span:nth-of-type(1) {
    z-index: -1;
    width: 100%;
    height: calc(170px + 4vh);
    background-color: ${(props) => props.theme.tenthColor};
  }
  > span:nth-of-type(2) {
    z-index: -3;
    flex: 1;
    width: 100%;
    background-color: ${(props) => props.theme.thirdColor};
    position: relative;
    overflow: hidden;
  }
`;
export const ThirdRowFirst = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: calc(100px + 4vh);

  && > p {
    font-size: 1.1rem;
  }
  p {
    font-size: 0.8rem;
    font-weight: bold;
    margin-bottom: 0;
    color: ${(props) => props.theme.firstColor};
  }

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 10px;

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 16%;
      aspect-ratio: 1 / 0.7;
      border-radius: 7px;
      box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.5);
      background-color: ${(props) => props.theme.tenthColor};
    }
  }
`;
export const ThirdRowSecond = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 6%;
  height: 60%;
  width: 100%;

  > p {
    font-weight: bold;
    color: ${(props) => props.theme.firstColor};
  }
`;
export const ThirdRowSecondOptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 10px;

  > div {
    width: 30%;
    filter: drop-shadow(0px 0px 7px rgba(0, 0, 0, 0.5));
    border-radius: 7px;

    > div {
      background-color: ${(props) => props.theme.tenthColor};

      img {
        width: 100%;
        height: 60%;
        object-fit: cover;
        object-position: center;
      }

      div {
        width: 100%;
        text-align: left;
        background-color: ${(props) => props.theme.tenthColor};
        padding: 1% 2% 2% 2%;

        button {
          width: 30%;
          height: 2rem;
          margin-left: 70%;
          background: #F6C665;
          color: ${(props) => props.theme.firstColor};
          border: none;
          font-weight: bold;
        }
      }
    }
  }
`;

// Icons
export const AutoLoansIcon = styled(AutoLoansSVG)`
  width: 3rem;
  height: 3rem;
  margin-bottom: 0.3rem;
  border-radius: 50%;
`;
export const HomeLoansIcon = styled(HomeLoansSVG)`
  width: 3rem;
  height: 3rem;
  margin-bottom: 0.3rem;
`;
export const InvestmentsIcon = styled(InvestmentsSVG)`
  width: 3rem;
  height: 3rem;
  margin-bottom: 0.3rem;
`;
export const PersonalLoansIcon = styled(PersonalLoansSVG)`
  width: 3rem;
  height: 3rem;
  margin-bottom: 0.3rem;
`;
export const OnlineBankingIcon = styled(OnlineBankingSVG)`
  width: 3rem;
  height: 3rem;
  margin-bottom: 0.3rem;
`;
